import { useTranslation } from 'react-i18next'

const highlights = [
  { id: 'h1', icon: 'ri-camera-3-line', key: 'highlightPhotography' },
  { id: 'h2', icon: 'ri-video-line', key: 'highlightVideography' },
  { id: 'h3', icon: 'ri-palette-line', key: 'highlightDesign' },
  { id: 'h4', icon: 'ri-printer-line', key: 'highlightPrinting' },
]

export default function AboutSection() {
  const { t } = useTranslation()

  return (
    <section id="about" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('about.label')}
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('about.title')}
            </h2>

            <p className="mt-6 text-base text-foreground-600 leading-relaxed">{t('about.para1')}</p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">{t('about.para2')}</p>

            <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {highlights.map((item) => (
                <div
                  key={item.id}
                  className="rounded-lg border border-background-200 bg-background-100/60 p-4 flex flex-col items-center text-center"
                >
                  <span className="w-11 h-11 rounded-full flex items-center justify-center bg-primary-100 text-primary-700 mb-2">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span className="text-xs md:text-sm font-medium text-foreground-800">{t(`about.${item.key}`)}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2 grid grid-cols-2 gap-4 md:gap-5">
            <div className="col-span-2 rounded-lg overflow-hidden h-56 md:h-72 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20photographer%20holding%20a%20camera%20in%20a%20warm%20elegant%20studio%2C%20behind%20the%20scenes%20of%20a%20luxury%20photo%20shoot%2C%20golden%20warm%20lighting%2C%20cinematic%20brown%20tones%2C%20soft%20bokeh%20background%2C%20premium%20editorial%20photography&width=1000&height=620&seq=shabi-about-01&orientation=landscape"
                alt="Shabi Media photographer at work in the studio"
                title="Professional photographer at Shabi Media studio, Madurai"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-44 md:h-56 border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20stack%20of%20golden%20photo%20frames%20and%20printed%20albums%20on%20a%20wooden%20table%2C%20warm%20ambient%20light%2C%20creative%20design%20studio%20desk%2C%20rich%20amber%20and%20brown%20tones%2C%20luxury%20product%20detail%20photography&width=700&height=800&seq=shabi-about-02&orientation=portrait"
                alt="Framed prints and albums by Shabi Media"
                title="Photo frames and print design by Shabi Media"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg overflow-hidden h-44 md:h-56 bg-primary-950 flex flex-col items-center justify-center text-center p-5">
              <i className="ri-double-quotes-l text-primary-400 text-3xl mb-3" />
              <p className="font-heading italic text-background-100 text-lg md:text-xl leading-snug">
                {t('about.quote')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}